import comp from "./SingleUserProfile";
export default comp;
